export var THEMES = [{
  name: "basic",
  displayName: "Basic",
  path: "themes/basic.css"
}, {
  name: "slashy",
  displayName: "Slashy",
  path: "themes/slashy.css"
}];
export var DEFAULT_THEME = "slashy"; // "basic"